import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/common/ppbxv2_user.png'
import _imports_1 from '@/assets/bauDo/enablenew.png'
import _imports_2 from '@/assets/common/kaiguan_guan.png'


const _hoisted_1 = { class: "report_container" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = { class: "table_container" }
const _hoisted_4 = { style: {"font-size":"10px","color":"#9ba7be","padding-top":"5px"} }
const _hoisted_5 = {
  key: 1,
  class: "noMoreData"
}

import CustomHeader from '../components/common/customHeader.vue';
import NoData from '../components/common/noData.vue';
import { ReportData } from '@/view/report/supportScript';


export default /*@__PURE__*/_defineComponent({
  __name: 'reportView',
  props: {
    dataSet: {}
  },
  emits: ['switchClick'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit

const props = __props
const clickToSwitch = () => {
    emits('switchClick')
}


return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CustomHeader, {
      text: _ctx.$t('report.directReport')
    }, null, 8, ["text"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_van_row, { class: "sub_row" }, {
        default: _withCtx(() => [
          _createVNode(_component_van_col, {
            span: "18",
            class: "icon_text"
          }, {
            default: _withCtx(() => [
              _cache[0] || (_cache[0] = _createElementVNode("img", {
                src: _imports_0,
                alt: ""
              }, null, -1)),
              _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('report.subordinate')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_van_col, {
            span: "6",
            class: "alignment row_text"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('report.effective')), 1),
              (_ctx.dataSet.checked)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _imports_1,
                    alt: "",
                    onClick: clickToSwitch
                  }))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: _imports_2,
                    alt: "",
                    onClick: clickToSwitch
                  }))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_van_row, { class: "tabel_head" }, {
          default: _withCtx(() => [
            _createVNode(_component_van_col, {
              span: "8",
              class: "tabel_alignment"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('report.name')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_van_col, {
              span: "2",
              class: "tabel_alignment"
            }),
            _createVNode(_component_van_col, {
              span: "6",
              class: "tabel_alignment"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('report.deposit')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_van_col, {
              span: "2",
              class: "tabel_alignment"
            }),
            _createVNode(_component_van_col, {
              span: "6",
              class: "tabel_alignment"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('report.bets')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet.descendantsList, (item, index) => {
          return (_openBlock(), _createBlock(_component_van_row, {
            class: "tabel_row",
            key: index,
            style: _normalizeStyle({
                backgroundColor: index % 2 === 1 ? 'transparent' : '#1a1d22'
            })
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, {
                span: "9",
                class: "tabel_alignment"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, _toDisplayString(item.userName), 1),
                  _createElementVNode("div", _hoisted_4, "ID: " + _toDisplayString(item.userCode), 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_van_col, {
                span: "8",
                class: "tabel_alignment"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.totalRecharge + " / " + item.rechargeRequire), 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_van_col, {
                span: "7",
                class: "tabel_alignment"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.totalTurnover + " / " + item.turnoverRequire), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["style"]))
        }), 128)),
        (_ctx.dataSet.descendantsList?.length == 0 || !_ctx.dataSet.descendantsList)
          ? (_openBlock(), _createBlock(NoData, { key: 0 }))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t("common.NoMoreData")), 1))
      ])
    ])
  ], 64))
}
}

})